// Reference conversions, implemented differently within the component
export const langSource = [
  {
    value: 'en',
    text: 'english',
  },
  {
    value: 'fr',
    text: 'french',
  },
  {
    value: 'es',
    text: 'spanish',
  },
];


export const idx_data_hand = [
  { value: '', text: '' },
  { value: 'right_hander', text: 'right_hander' },
  { value: 'left_hander', text: 'left_hander' },
];

export const idx_data_grip = [
  { value: '', text: '' },
  { value: 'conventional', text: 'conventional' },
  { value: 'finger_tip', text: 'finger_tip' },
];

export const displayMeasurementsSource = [
  {
    value: 'fraction',
    text: 'fraction',
  },
  {
    value: 'decimal',
    text: 'decimal',
  },
];

export const pitchMeasurementsSource = [
  {
    value: '16',
    text: '16ths',
  },
  {
    value: '16+',
    text: '16+ths',
  },
  {
    value: '32',
    text: '32ths',
  },
  {
    value: '32+',
    text: '32+ths',
  },
  {
    value: '64',
    text: '64ths',
  },
];

export const spanMeasurementsSource = [
  {
    value: '16',
    text: '16ths',
  },
  {
    value: '16+',
    text: '16+ths',
  },
  {
    value: '32',
    text: '32ths',
  },
  {
    value: '32+',
    text: '32+ths',
  },
  {
    value: '64',
    text: '64ths',
  },
];

export const angleMeasurementsSource = [
  {
    value: '5',
    text: '5°',
  },
  {
    value: '1',
    text: '1°',
  },
];

export const ovalCalculationSource = [
  {
    value: 'trigonometry',
    text: 'top_to_bottom',
    // text: 'vh',
  },
  {
    value: 'horizontal',
    text: 'horizontal',
    // text: 'h',
  },
  // {
  //     value: 'center_out',
  //     text: 'center_out')
  //     text: 'v')
  // },
  {
    value: 'manual',
    text: 'manual',
    // text: 'none',
  },
];

export const pitchCenterEdgeSource = [
  {
    value: 'edge',
    text: 'edge',
  },
  {
    value: 'center',
    text: 'center',
  },
];

export const arsenalLayoutSource = [
  {
    value: 'dual_angle',
    text: 'dual_angle',
  },
  {
    value: 'vls',
    text: 'vls',
  },
  {
    value: 'none',
    text: 'none',
  },
];

export const syncSource = [
  {
    value: 5 * 60 * 1000 + '',
    text: '5m',
  },
  {
    value: 10 * 60 * 1000 + '',
    text: '10m',
  },
  {
    value: 15 * 60 * 1000 + '',
    text: '15m',
  },
];
